import { css } from "styled-components";

const sizes = {
  bigBigDesktop: 1920,
  bigDesktop: 1320,
  desktop: 992,
  tablet: 768,
  phone: 576
};

export default Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});
